import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { FaCheckCircle, FaStore, FaBoxOpen } from 'react-icons/fa';

const PublicProductView = () => {
    const { id } = useParams();
    const [product, setProduct] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // हम एक नया पब्लिक API बनाएंगे जो बिना लॉगिन के प्रोडक्ट दिखाएगा
        axios.get(`/api/products/public/${id}`)
            .then(res => {
                setProduct(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, [id]);

    if (loading) return <div className="h-screen flex items-center justify-center font-bold">Loading Details...</div>;
    if (!product) return <div className="h-screen flex items-center justify-center font-bold text-red-500">Product not found!</div>;

    return (
        <div className="min-h-screen bg-gray-100 flex flex-col items-center p-4 font-sans">
            <div className="w-full max-w-md bg-white rounded-3xl shadow-xl overflow-hidden mt-6">
                {/* 🖼️ Product Image */}
                <div className="w-full h-64 bg-gray-50 flex justify-center items-center border-b p-4">
                    {product.image ? (
                        <img src={product.image} alt={product.name} className="max-h-full object-contain" />
                    ) : (
                        <FaBoxOpen size={80} className="text-gray-300" />
                    )}
                </div>

                {/* 📝 Product Details */}
                <div className="p-6">
                    <div className="flex justify-between items-start mb-2">
                        <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-[10px] font-bold uppercase tracking-wider">
                            {product.brand || 'Generic'}
                        </span>
                        <span className="flex items-center gap-1 text-green-600 text-xs font-bold bg-green-50 px-2 py-1 rounded">
                            <FaCheckCircle/> Verified
                        </span>
                    </div>

                    <h1 className="text-2xl font-black text-gray-800 leading-tight mb-2">{product.name}</h1>
                    
                    <div className="bg-gray-50 rounded-xl p-4 my-4 grid grid-cols-2 gap-4">
                        <div>
                            <p className="text-[10px] text-gray-500 uppercase font-bold">Size / Variant</p>
                            <p className="font-bold text-gray-800">{product.size || 'Standard'}</p>
                        </div>
                        <div>
                            <p className="text-[10px] text-gray-500 uppercase font-bold">Item Code</p>
                            <p className="font-bold text-gray-800">{product.itemCode || 'N/A'}</p>
                        </div>
                    </div>

                    <div className="border-t pt-4 flex justify-between items-center">
                        <p className="text-sm text-gray-500">M.R.P.</p>
                        <p className="text-3xl font-black text-slate-900">₹{product.sellingPrice || product.price}</p>
                    </div>
                </div>

                {/* Footer (Shop Name) */}
                <div className="bg-slate-900 text-white p-4 text-center flex items-center justify-center gap-2">
                    <FaStore />
                    <span className="font-bold text-sm">{product.shopId?.shopName || 'Bhavya AI™ Partner Store'}</span>
                </div>
            </div>
        </div>
    );
};

export default PublicProductView;